<h1
  mat-dialog-title
  translate="inbox/task-list/mass-actions/answer/confirm-button"
  [translateParams]="{ nb: nbMessages }"></h1>
<mat-dialog-content>
  <app-message-editor-wrapper
    [control]="editorControl"
    [site]="site"
    [isPrivate]="isPrivate"></app-message-editor-wrapper>

  <p
    *ngIf="isConfirmationVisible"
    class="confirmation"
    [innerHtml]="'inbox/task-list/mass-actions/answer/confirmation' | translate: { nb: nbMessages }"></p>

  <mat-slide-toggle
    *ngIf="isConfirmationVisible"
    [(ngModel)]="isConfirmationChecked"
    [class.confirmed]="isConfirmationChecked"
    data-testid="confirm-checkbox"
    ><span translate="inbox/task-list/mass-actions/answer/sure"></span
  ></mat-slide-toggle>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-raised-button
    type="button"
    color="primary"
    class="confirm"
    [class.confirmed]="isConfirmationChecked"
    [disabled]="editorControl.invalid || (isConfirmationVisible && !isConfirmationChecked)"
    (click)="confirm()">
    <span translate="inbox/task-list/mass-actions/answer/confirm-button" [translateParams]="{ nb: nbMessages }"></span>
  </button>
  <button mat-raised-button type="button" (click)="cancel()"><span translate="cancel"></span></button>
</mat-dialog-actions>

<app-progression-dialog
  *ngIf="showProgressionDialog"
  [data]="progressionDialogData"
  (closeDialog)="closeProgressionDialog()"></app-progression-dialog>
